import React, { useState, useEffect } from 'react'
import 'katex/dist/katex.min.css'
import { KnovaText } from '../BasicUIComponents/KnovaText'

function SCTrueFalseComponent(props) {
  const {
    isPractice,
    Completed,
    isActive,
    componentData,
    themeColors,
    themeFont,
    themeStyles,
    isSideMenu,
    isFollowTheFlow,
    priorityActive,
    isAudioPlaying,
    isMinimize,
    isReplaying
  } = props
  const {
    defaultValue,
    onValueChange,
    onPriorityChange,
    handleSucAndFailFeedback
  } = props

  const { ControlID, Answers, Options, Score, Priority, FeedbackAudioData } =
    componentData

  const [trueFalseValueArray, setTrueFalseValueArray] = useState([])
  const [failureCount, setFailureCount] = useState(0)
  const [onBlurCall, setOnBlurCall] = useState(true)

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue) {
        if (defaultValue.CtlValue) {
          let defaultValueSelected = defaultValue.CtlValue
          setTrueFalseValueArray(defaultValueSelected)
        }
        setOnBlurCall(false)
      } else {
        let valueArray = []
        for (let i = 0; i < Options.length; i++) {
          valueArray[i] = ''
        }
        setTrueFalseValueArray(valueArray)
      }
    }
  }, [defaultValue, onBlurCall])

  //Failure message Sequence
  function handleFailureFeedback() {
    let feedbackAudioData = FeedbackAudioData.failureData
    let failureFeedback = {}
    if (feedbackAudioData.length > 0) {
      if (failureCount === 0) {
        if (feedbackAudioData[1]) {
          setFailureCount(1)
        } else {
          setFailureCount(0)
        }
        failureFeedback = feedbackAudioData[0]
      } else if (failureCount === 1) {
        if (feedbackAudioData[2]) {
          setFailureCount(2)
        } else {
          setFailureCount(0)
        }
        failureFeedback = feedbackAudioData[1]
      } else if (failureCount === 2) {
        setFailureCount(0)
        failureFeedback = feedbackAudioData[2]
      }
    } else {
      failureFeedback = {
        failureAudioLink: '',
        failureFeedback: []
      }
    }
    handleSucAndFailFeedback(false, failureFeedback)
  }

  function handleSelection(index, selectionType) {
    let trueFalseValueArrayCopy = [...trueFalseValueArray]
    trueFalseValueArrayCopy[index] = selectionType
    setTrueFalseValueArray(trueFalseValueArrayCopy)
    validateCorrectAnswer(false, trueFalseValueArrayCopy)
  }

  function validateCorrectAnswer(timerValue, trueFalseValueArrayCopy) {
    //check all the t/f are attend
    let selectedCopy = []
    for (let index = 0; index < trueFalseValueArrayCopy.length; index++) {
      if (trueFalseValueArrayCopy[index] !== undefined) {
        selectedCopy.push(trueFalseValueArrayCopy[index])
      }
    }
    //Change priority value
    if (onPriorityChange && isFollowTheFlow) {
      if (isPractice) {
        if (
          JSON.stringify(trueFalseValueArrayCopy) === JSON.stringify(Answers)
        ) {
          // onPriorityChange(Priority)
        }
      } else {
        if (selectedCopy.length >= Answers.length) {
          onPriorityChange(Priority)
        }
      }
    }

    if (JSON.stringify(trueFalseValueArrayCopy) === JSON.stringify(Answers)) {
      onValueChange(ControlID, trueFalseValueArrayCopy, Score, Score, '', false)
      if (isPractice && isFollowTheFlow) {
        //check selected answer correct for feedback
        if (selectedCopy.length >= Answers.length) {
          const canGoToNextStep = selectedCopy.every((item) => item !== '')
          if (canGoToNextStep) {
            handleSucAndFailFeedback(true, FeedbackAudioData.successData)
          }
        }
      }
    } else {
      onValueChange(ControlID, trueFalseValueArrayCopy, 0, Score, '', false)
      if (isPractice && isFollowTheFlow) {
        //check selected answer correct for feedback

        if (selectedCopy.length >= Answers.length) {
          const canGoToNextStep = selectedCopy.every((item) => item !== '')
          if (canGoToNextStep) {
            handleFailureFeedback()
          }
        }
      }
    }
  }

  return (
    <div
      className='sc-tf-cont'
      style={{
        filter: isFollowTheFlow
          ? Priority <= priorityActive
            ? 'unset'
            : 'blur(3px)'
          : 'unset',
        gap: isSideMenu ? '5px' : isMinimize ? '24px' : '30px',
        pointerEvents:
          Completed === 1 ||
          !isActive ||
          isAudioPlaying ||
          isReplaying ||
          isSideMenu
            ? 'none'
            : isFollowTheFlow
            ? isPractice
              ? Priority === priorityActive
                ? 'auto'
                : 'none'
              : Priority > priorityActive
              ? 'none'
              : 'auto'
            : 'auto',
        justifyContent: isMinimize ? 'center' : 'start'
      }}
    >
      {Options &&
        Options.map((item, index) => {
          return (
            <div
              className='tf-body'
              style={{ gap: isSideMenu ? '6px' : '16px' }}
            >
              <div className='tf-quest-cont'>
                <KnovaText
                  contBgColor={themeColors.background}
                  contPadding={isSideMenu ? '1px' : '16px 24px'}
                  contBorderColor={themeColors.outlineVarient}
                  contBorderWidth='1px'
                  contBorderRadius={isSideMenu ? '1px' : '4px'}
                  text={isSideMenu ? 'Question ' + (index + 1) : item}
                  textColor={themeColors.onBackground}
                  textFontSize={
                    isSideMenu ? '5px' : isMinimize ? '16px' : '22px'
                  }
                  textFontFamily={themeFont.bodyFont}
                  textFontWeight='500'
                />
              </div>
              <div
                className='tf-box-cont'
                onClick={() => {
                  if (isPractice && isFollowTheFlow) {
                    if (
                      JSON.stringify(trueFalseValueArray) ===
                      JSON.stringify(Answers)
                    ) {
                    } else {
                      handleSelection(index, true)
                    }
                  } else {
                    handleSelection(index, true)
                  }
                }}
              >
                <KnovaText
                  contBgColor={
                    isPractice || Completed === 1 || !isActive
                      ? trueFalseValueArray[index] === true
                        ? Answers[index] === true
                          ? themeColors.success
                          : themeColors.error
                        : themeColors.background
                      : trueFalseValueArray[index] === true
                      ? themeStyles.selectionColor
                      : themeColors.background
                  }
                  // contMargin={isSideMenu ? '4px 0px' : '9px 0px'}
                  contPadding={isSideMenu ? '1px' : '16px 24px'}
                  contBorderColor={
                    isPractice || Completed === 1 || !isActive
                      ? trueFalseValueArray[index] === true
                        ? Answers[index] === true
                          ? themeColors.successContainer
                          : themeColors.errorContainer
                        : themeColors.outlineVarient
                      : trueFalseValueArray[index] === true
                      ? themeColors.outline
                      : themeColors.outlineVarient
                  }
                  contBorderWidth='1px'
                  contBorderRadius={isSideMenu ? '1px' : '4px'}
                  text='True'
                  textColor={
                    isPractice || Completed === 1 || !isActive
                      ? trueFalseValueArray[index] === true
                        ? Answers[index] === true
                          ? themeColors.onSuccess
                          : themeColors.onError
                        : themeColors.onBackground
                      : trueFalseValueArray[index] === true
                      ? themeStyles.selectionTextColor
                      : themeColors.onBackground
                  }
                  textFontSize={
                    isSideMenu ? '5px' : isMinimize ? '16px' : '22px'
                  }
                  textFontFamily={themeFont.bodyFont}
                  textFontWeight={
                    trueFalseValueArray[index] === true ? '700' : '500'
                  }
                  cursor='pointer'
                />
              </div>
              <div
                className='tf-box-cont'
                onClick={() => {
                  if (isPractice && isFollowTheFlow) {
                    if (
                      JSON.stringify(trueFalseValueArray) ===
                      JSON.stringify(Answers)
                    ) {
                    } else {
                      handleSelection(index, false)
                    }
                  } else {
                    handleSelection(index, false)
                  }
                }}
              >
                <KnovaText
                  contBgColor={
                    isPractice || Completed === 1 || !isActive
                      ? trueFalseValueArray[index] === false
                        ? Answers[index] === false
                          ? themeColors.success
                          : themeColors.error
                        : themeColors.background
                      : trueFalseValueArray[index] === false
                      ? themeStyles.selectionColor
                      : themeColors.background
                  }
                  // contMargin={isSideMenu ? '4px 0px' : '9px 0px'}
                  contPadding={isSideMenu ? '2px' : '16px 24px'}
                  contBorderColor={
                    isPractice || Completed === 1 || !isActive
                      ? trueFalseValueArray[index] === false
                        ? Answers[index] === false
                          ? themeColors.successContainer
                          : themeColors.errorContainer
                        : themeColors.outlineVarient
                      : trueFalseValueArray[index] === false
                      ? themeColors.outline
                      : themeColors.outlineVarient
                  }
                  contBorderWidth='1px'
                  contBorderRadius={isSideMenu ? '1px' : '4px'}
                  text='False'
                  textColor={
                    isPractice || Completed === 1 || !isActive
                      ? trueFalseValueArray[index] === false
                        ? Answers[index] === false
                          ? themeColors.onSuccess
                          : themeColors.onError
                        : themeColors.onBackground
                      : trueFalseValueArray[index] === false
                      ? themeStyles.selectionTextColor
                      : themeColors.onBackground
                  }
                  textFontSize={
                    isSideMenu ? '5px' : isMinimize ? '16px' : '22px'
                  }
                  textFontFamily={themeFont.bodyFont}
                  textFontWeight={
                    trueFalseValueArray[index] === false ? '700' : '500'
                  }
                  cursor='pointer'
                />
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default SCTrueFalseComponent
